import { render, staticRenderFns } from "./mktSpacing.vue?vue&type=template&id=cd135b30&"
import script from "./mktSpacing.vue?vue&type=script&lang=js&"
export * from "./mktSpacing.vue?vue&type=script&lang=js&"
import style0 from "./mktSpacing.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports